import React, { createContext, useContext } from 'react';

import { ClubsEntityNormalized } from '../../../../../../../store/product/types';

interface ClubsAssetContextReceivedData {}

type ClubsEntityNormalizedWithAccountId = ClubsEntityNormalized & {
  accountId: number;
};

interface ClubsAssetContextData extends ClubsAssetContextReceivedData {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  offerSelected: ClubsEntityNormalizedWithAccountId | undefined;
  setOfferSelected: React.Dispatch<
    React.SetStateAction<ClubsEntityNormalizedWithAccountId | undefined>
  >;
}

interface Props extends ClubsAssetContextReceivedData {
  children: React.ReactNode;
}

const ClubsAssetContext = createContext<ClubsAssetContextData>({} as ClubsAssetContextData);

const ClubsAssetProvider: React.FC<Props> = ({ children, ...props }) => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [offerSelected, setOfferSelected] = React.useState<ClubsEntityNormalizedWithAccountId>();

  return (
    <ClubsAssetContext.Provider
      value={{
        ...props,
        modalOpen,
        setModalOpen,
        offerSelected,
        setOfferSelected,
      }}>
      {children}
    </ClubsAssetContext.Provider>
  );
};

const useClubsAssetContext = (): ClubsAssetContextData => {
  const context = useContext(ClubsAssetContext);

  if (!context) {
    throw new Error('useClubsAssetContext must be used within an ClubsAssetContext');
  }
  return context;
};

export { ClubsAssetProvider, useClubsAssetContext, ClubsAssetContextData };
